// extracted by mini-css-extract-plugin
export default {"autocompleteInput":"AddressLookupSwissField__autocompleteInput--13S","toggleManualInput":"AddressLookupSwissField__toggleManualInput--1Yl"};